import React, { useCallback } from 'react';

import { ChipsItem, Label } from '@atlas/ui';

import useTranslate from 'common/I18n/Interpreter';
import { useCasinoFilterState } from 'components/Pages/Casino/CasinoFilterContext';
import {
  casinoFilterTypeMap,
  toggleCasinoFilterListItem,
} from 'components/Pages/Casino/useCasinoFilter';

const MultiFilterSelectedList = () => {
  const t = useTranslate();
  const {
    filter: { providerNames },
    updateFilter,
  } = useCasinoFilterState();

  const resetProviderItem = useCallback(
    value => {
      toggleCasinoFilterListItem(casinoFilterTypeMap.providerNames, value);

      const newProviders = () => {
        if (providerNames.includes(value)) {
          return providerNames.filter(el => el !== value);
        }
        return [...providerNames, value];
      };
      const newProviderNames = newProviders();

      if (!providerNames.length) return;

      updateFilter({ providerNames: newProviderNames });
    },
    [providerNames],
  );

  if (!providerNames || !providerNames.length) {
    return null;
  }

  return (
    <>
      <div className="chips-list casino-inline-filter">
        <div className="casino-filter-title">{t('filters')}:</div>
        {providerNames.map(name => {
          const keyName = name.toLowerCase();

          const label = <Label message={keyName} />;

          return (
            <ChipsItem
              active
              className="row"
              icon="close"
              label={label}
              onClick={() => resetProviderItem(name)}
            />
          );
        })}
      </div>
    </>
  );
};

export default MultiFilterSelectedList;
